/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Retailer with logo and link
 * @export
 * @interface SurfaceRetailer
 */
export interface SurfaceRetailer {
    /**
     * 
     * @type {string}
     * @memberof SurfaceRetailer
     */
    _id?: string;
    /**
     * 
     * @type {string}
     * @memberof SurfaceRetailer
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof SurfaceRetailer
     */
    logoImageId?: string;
    /**
     * Resolved from logoImageId on read; absent when the logo is an external logoUrl.
     * @type {string}
     * @memberof SurfaceRetailer
     */
    logoImageUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof SurfaceRetailer
     */
    logoUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof SurfaceRetailer
     */
    productUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof SurfaceRetailer
     */
    type?: SurfaceRetailerTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof SurfaceRetailer
     */
    exclusive?: string;
}


/**
 * @export
 */
export const SurfaceRetailerTypeEnum = {
    online: 'online',
    InStore: 'in-store',
    both: 'both'
} as const;
export type SurfaceRetailerTypeEnum = typeof SurfaceRetailerTypeEnum[keyof typeof SurfaceRetailerTypeEnum];


/**
 * Check if a given object implements the SurfaceRetailer interface.
 */
export function instanceOfSurfaceRetailer(value: object): value is SurfaceRetailer {
    return true;
}

export function SurfaceRetailerFromJSON(json: any): SurfaceRetailer {
    return SurfaceRetailerFromJSONTyped(json, false);
}

export function SurfaceRetailerFromJSONTyped(json: any, ignoreDiscriminator: boolean): SurfaceRetailer {
    if (json == null) {
        return json;
    }
    return {
        
        '_id': json['_id'] == null ? undefined : json['_id'],
        'name': json['name'] == null ? undefined : json['name'],
        'logoImageId': json['logoImageId'] == null ? undefined : json['logoImageId'],
        'logoImageUrl': json['logoImageUrl'] == null ? undefined : json['logoImageUrl'],
        'logoUrl': json['logoUrl'] == null ? undefined : json['logoUrl'],
        'productUrl': json['productUrl'] == null ? undefined : json['productUrl'],
        'type': json['type'] == null ? undefined : json['type'],
        'exclusive': json['exclusive'] == null ? undefined : json['exclusive'],
    };
}

export function SurfaceRetailerToJSON(json: any): SurfaceRetailer {
    return SurfaceRetailerToJSONTyped(json, false);
}

export function SurfaceRetailerToJSONTyped(value?: SurfaceRetailer | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        '_id': value['_id'],
        'name': value['name'],
        'logoImageId': value['logoImageId'],
        'logoImageUrl': value['logoImageUrl'],
        'logoUrl': value['logoUrl'],
        'productUrl': value['productUrl'],
        'type': value['type'],
        'exclusive': value['exclusive'],
    };
}

